<template>
  <div class="f-shop-detail">
    <div class="tabs-box">
      <el-tabs v-model="tabsKey" @tab-click="onTabsClick" type="card">
        <el-tab-pane v-for="item in tabsList" :key="item.name" :label="item.label" :name="item.name"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="content-box" ref="content-box" @scroll="onScroll">
      <div ref="content">
        <baseInfo :baseInfo="baseInfo" @onLook="onLook"></baseInfo>
        <rentRate v-if="USER_BUTTON_AUTH.indexOf('finance\:store\:ratio\:detail') >= 0" :defaultRatio="defaultRatio" :storeDisable="baseInfo.disable" @initPage="initPage"></rentRate>
        <subsidySettlement v-if="USER_BUTTON_AUTH.indexOf('subsidySettle\:read') >= 0" :subsidySettleConfig="subsidySettleConfig" :storeDisable="subsidySettleConfig.disable" @initPage="initPage"></subsidySettlement>
        <activityRate v-if="USER_BUTTON_AUTH.indexOf('finance\:store\:ratio\:detail') >= 0" :activiceRatio="activiceRatio" :storeDisable="baseInfo.disable" @initPage="initPage"></activityRate>
        <reconciliationInfo v-if="USER_BUTTON_AUTH.indexOf('statement\:read') >= 0" @initPage="initPage"></reconciliationInfo>
      </div>
    </div>
    <div class="footer">
      <el-button @click="onBack" class="mr20">返回</el-button>
    </div>
  </div>
</template>

<script>
import { getStorage } from '@/utils/index'
import AuthButton from '@/components/AuthButton'
import { api_getShopDetailData, api_getShopPhone, api_getShopBankcardNo } from '@/api/finance'
import baseInfo from './components/baseInfo'
import rentRate from './components/rentRate'
import activityRate from './components/activityRate'
import subsidySettlement from './components/subsidySettlement'
import reconciliationInfo from './components/reconciliationInfo'

export default {
  name: "fsDetail",
  components: {
    AuthButton,
    baseInfo,
    rentRate,
    activityRate,
    subsidySettlement,
    reconciliationInfo
  },
  data() {
    return {
      USER_BUTTON_AUTH: [],
      tabsList: [
        {label: '基础信息', name: 'baseInfo'},
        {label: '租务费率', name: 'rentRate', auth: 'finance:store:ratio:detail'},
        {label: '补贴结算', name: 'subsidySettlement', auth: 'subsidySettle:read'},
        {label: '活动费率', name: 'activityRate', auth: 'finance:store:ratio:detail'},
        {label: '对账信息', name: 'reconciliationInfo', auth: 'statement:read'},
      ],
      tabsKey: 'baseInfo',
      itemOffsetTop: [],
      timeId: null,
      baseInfo: {}, // 店铺基础信息数据
      defaultRatio: {}, // 租务费率
      activiceRatio: {}, // 活动费率
      subsidySettleConfig:{} //补贴结算
    };
  },
  async created() {
    this.USER_BUTTON_AUTH = getStorage('USER_BUTTON_AUTH')
    this.setTabsList() // 设置tab数据
    await this.getDetailData() // 获取店铺详情数据
    this.tabsKey = this.$route.query.tab || 'baseInfo'
  },
  mounted() {
  },
  methods: {
    // 设置tab数据
    setTabsList() {
      this.tabsList = this.tabsList.filter(item => !item.auth || this.USER_BUTTON_AUTH.indexOf(item.auth) >= 0)
    },

    // 获取店铺详情数据
    async getDetailData() {
      try {
        const res = await api_getShopDetailData({id: this.$route.query.id})
        console.log('res: ', res);
        this.baseInfo = res.baseInfo || {}
        this.defaultRatio = res.defaultRatio || {}
        this.activiceRatio = res.activiceRatio || {}
        this.subsidySettleConfig = res.subsidySettleConfig || {}
      } catch(err) {
        console.log('err: ', err);
      }
    },

    // 查看、隐藏手机号、银行账号
    async onLook(name) {
      console.log('name: ', name);
      let baseInfo = {...this.baseInfo}
      if (name == 'phone') {
        if (baseInfo.contractorPhone_show) {
          delete baseInfo.contractorPhone_show
        } else {
          const {contractorPhone=''} = await api_getShopPhone({storeId: this.$route.query.id})
          baseInfo.contractorPhone_show = contractorPhone
        }
      } else if (name == 'bankcardNo') {
        if (baseInfo.bankcardNo_show) {
          delete baseInfo.bankcardNo_show
        } else {
          const {bankcardNo=''} = await api_getShopBankcardNo({financeId: baseInfo.financeId})
          baseInfo.bankcardNo_show = bankcardNo
        }
      }
      this.baseInfo = baseInfo
    },

    // 初始化页面
    initPage() {
      setTimeout(() => {
        let arr = []
        const tabs = document.getElementsByClassName('tabs-item')
        for (let i = 0; i < tabs.length; i++) {
          let obj = {
            tabName: tabs[i].id,
            offsetTop: tabs[i].offsetTop
          }
          arr.push(obj)
        }
        this.itemOffsetTop = arr
        this.$route.query.tab && this.onTabsClick({name: this.$route.query.tab})
      }, 500)
    },

    // tabs点击
    onTabsClick(e) {
      document.getElementById(e.name).scrollIntoView()
    },

    // 页面滚动，高亮tab
    onScroll() {
      clearTimeout(this.timeId) // 防抖
      let timeId = setTimeout(() => {
        let scrollTop = this.$refs['content-box'].scrollTop
        let contentBoxHeight = this.$refs['content-box'].clientHeight // 滚动盒子高度
        let contentHeight = this.$refs['content'].clientHeight // 内容区域总高

        for (let i = 0; i < this.itemOffsetTop.length; i++) {
          if (scrollTop >= this.itemOffsetTop[i].offsetTop - 100) {
            this.tabsKey = this.itemOffsetTop[i].tabName
          }
        }
        // 滚动到底，高亮最后一个tab
        if (contentBoxHeight + scrollTop >= contentHeight ) {
          console.log('this.itemOffsetTop: ', this.itemOffsetTop);
          this.tabsKey = this.itemOffsetTop[this.itemOffsetTop.length - 1].tabName
        }
      }, 200)
      this.timeId = timeId
    },

    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
  watch: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
.f-shop-detail {
  width: 100%;
  // padding: 0 19px;
  // padding-bottom: 50px;
  box-sizing: border-box;
  position: relative;
  background-color: #f6f8f9;

  .tabs-box {
    padding: 0 20px;
    padding-top: 20px;
    margin-bottom: 1px;
    background-color: #fff;
    position: relative;
    z-index: 100;
  }

  .content-box {
    max-height: calc(100vh - 210px);
    overflow: auto;
    margin-top: -16px;
    position: relative;

    .tabs-item {
      position: relative;
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
